import { usePriorityModalMeta } from "@/shared/atoms/usePriorityModal";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Modal, { ModalProps } from "../Modal/Modal";

export interface PendingPaymentModalMeta {
  itemId?: number;
  callback: () => void;
  eventName: string;
}

const duration = 45000;

export const ProgressButton = ({ className = "", ...props }) => (
  <button
    className={`relative w-full touch-manipulation overflow-hidden rounded-[18px] border-none bg-[#16a34a] py-[22px] text-[22px] font-semibold text-white active:scale-[0.98] ${className}`.trim()}
    {...props}
  />
);

export const ProgressFill = ({ className = "", ...props }) => (
  <div
    className={`absolute inset-0 transition-[width] duration-75 ease-linear ${className}`.trim()}
    {...props}
  />
);

export const ButtonText = ({ className = "", ...props }) => (
  <span className={`relative z-[1] ${className}`.trim()} {...props} />
);

const KioskIdleModal = (props: ModalProps) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const start = Date.now();

    const interval = setInterval(() => {
      const elapsed = Date.now() - start;
      const value = Math.min(elapsed / duration, 1);
      setProgress(value);

      if (value === 1) {
        clearInterval(interval);
      }
    }, 50);

    return () => clearInterval(interval);
  }, [duration]);

  const { t } = useTranslation();
  const [meta] = usePriorityModalMeta();
  const { onConfirm } = meta;
  return (
    <Modal
      onExit={() => {
        onConfirm && onConfirm();
        props.onExit && props.onExit();
      }}
      width="40rem"
      {...props}
      zIndex={10000001}
    >
      <h2 className="mb-4 text-[32px] font-bold">{t("areYouStillHere")}</h2>
      <p className="mb-10 text-[18px] leading-[1.4] text-[#555]">{t("kioskAutoReset")}</p>

      <ProgressButton onClick={onConfirm}>
        <ProgressFill style={{ width: `${progress * 100}%`, background: "rgba(255, 255, 255, 0.25)" }} />
        <ButtonText>{t("yesIAmStillHere")}</ButtonText>
      </ProgressButton>
    </Modal>
  );
};

export default KioskIdleModal;
